<template>
  <div>
    <Card>
      <Form ref="formInline" :model="searchForm" inline>
        <Row :gutter="20">
          <i-col :span="4">
            <FormItem prop="publisherId" label="Account ID" :label-width="100">
              <Select v-model="searchForm.publisherId" clearable>
                <Option 
                  v-for="item in accountOptions" 
                  :key="item.value" 
                  :value="item.value"
                >
                  {{ item.value }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col :span="4">
            <FormItem prop="offerId" label="Offer ID" :label-width="70">
              <i-input v-model.trim="searchForm.offerId" placeholder="ID" clearable></i-input>
            </FormItem>
          </i-col>
          <i-col :span="4">
            <FormItem prop="pkg" label="Pkg" :label-width="50">
              <i-input v-model.trim="searchForm.pkg" placeholder="Pkg" clearable></i-input>
            </FormItem>
          </i-col>
          <i-col :span="6">
            <FormItem label="Date" :label-width="50">
              <DatePicker 
                v-model="searchForm.dateRange" 
                :clearable="false" 
                type="daterange" 
                placement="bottom-end" 
                placeholder="Select date"
                style="width: 100%">
              </DatePicker>
            </FormItem>
          </i-col>
          <i-col :span="4">
            <FormItem>
              <Button type="primary" @click="handleSearch">Search</Button>
            </FormItem>
          </i-col>
        </Row>
      </Form>
    </Card>

    <Card>
      <div style="text-align:right;margin-bottom: 12px;">
        <Button :loading="downloading" icon="ios-download" type="primary" @click="handleDownload">export</Button>
      </div>
      <Table 
        :columns="getColumns" 
        :data="tableData" 
        :loading="loading" 
        border 
        stripe
        :row-class-name="rowClassName"
      >
      </Table>
      <div class="pagination-container">
        <Page
          :total="total"
          :current="page"
          :page-size="pageSize"
          :page-size-opts="pageSizeOpts"
          show-sizer
          show-total
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSizeChange"
        />
      </div>
    </Card>
  </div>
</template>

<script>
import {
  Card,
  Form,
  FormItem,
  Input,
  Button,
  Table,
  Page,
  DatePicker,
  Row,
  Col,
  Select,
  Option
} from "view-design";
import { getCpsRevenue, exportCpsRevenue, getPublisherList } from "@/server";
import moment from 'moment';

export default {
  name: "CpsOfferRevenue",
  components: {
    Card,
    Form,
    FormItem,
    "i-input": Input,
    Button,
    Table,
    Page,
    DatePicker,
    Row,
    "i-col": Col,
    Select,
    Option
  },
  data() {
    return {
      searchForm: {
        publisherId: "",
        dateRange: [
          moment().subtract(7, 'days').format('YYYY-MM-DD'), 
          moment().subtract(1, 'days').format('YYYY-MM-DD')
        ],
        offerId: "",
        pkg: ""
      },
      loading: false,
      downloading: false,
      total: 0,
      page: 1,
      pageSize: 50,
      pageSizeOpts: [10, 20, 50, 100],
      columns: [
        {
          title: "Date",
          key: "date",
          width: 120
        },
        {
          title: "Offer ID",
          key: "ads_id",
          width: 120
        },
        {
          title: "Pkg",
          key: "pkg",
          minWidth: 120
        },
        {
          title: "Click",
          key: "click_count",
          width: 100
        },
        {
          title: "Total Install",
          key: "installs",
          width: 130
        },
        {
          title: "CVR",
          key: "cvr",
          width: 100,
          render: (h, params) => {
            return h('span', params.row.cvr + '%')
          }
        },
        {
          title: "Reject",
          key: "reject_count",
          width: 110
        },
        {
          title: "Reject Rate",
          key: "reject_rate",
          width: 150,
          render: (h, params) => {
            const value = params.row.reject_rate || 0;
            const shouldWarn = parseFloat(value) > 30 && params.row.reject_count > 0;
            return h('div', {
              class: {
                'reject-rate-warning': shouldWarn
              },
              style: {
                color: shouldWarn ? '#ed4014' : 'inherit',
                fontWeight: shouldWarn ? 'bold' : 'normal',
                display: 'flex',
                alignItems: 'center',
                padding: '0 16px'
              }
            }, [
              shouldWarn && h('Icon', {
                props: {
                  type: 'md-warning',
                  color: '#ed4014'
                },
                style: {
                  marginRight: '4px'
                }
              }),
              h('span', value + '%')
            ]);
          }
        },
        {
          title: "DDJ Install：协议 Install",
          key: "dpRate",
          width: 200,
          render: (h, params) => {
            return h('span', Number(params.row.dpRate || 0).toFixed(2))
          }
        },
        {
          title: "可分成收益",
          key: "share_count",
          width: 110
        },
        {
          title: "分成",
          key: "revenue",
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', '$' + (params.row.revenue || 0).toFixed(2))
          }
        }
      ],
      tableData: [],
      accountOptions: [],
      publisherId: null
    };
  },
  computed: {
    getColumns() {
      return [
        {
          title: "Date",
          key: "date",
          width: 120
        },
        {
          title: "Offer ID",
          key: "ads_id",
          width: 120
        },
        {
          title: "Pkg",
          key: "pkg",
          minWidth: 120
        },
        {
          title: "Click",
          key: "click_count",
          width: 100
        },
        {
          title: "Total Install",
          key: "installs",
          width: 130
        },
        {
          title: "CVR",
          key: "cvr",
          width: 100,
          render: (h, params) => {
            return h('span', params.row.cvr + '%')
          }
        },
        {
          title: "Reject",
          key: "reject_count",
          width: 110
        },
        {
          title: "Reject Rate",
          key: "reject_rate",
          width: 150,
          render: (h, params) => {
            const value = params.row.reject_rate || 0;
            const shouldWarn = parseFloat(value) > 30 && params.row.reject_count > 0;
            return h('div', {
              class: {
                'reject-rate-warning': shouldWarn
              },
              style: {
                color: shouldWarn ? '#ed4014' : 'inherit',
                fontWeight: shouldWarn ? 'bold' : 'normal',
                display: 'flex',
                alignItems: 'center',
                padding: '0 16px'
              }
            }, [
              shouldWarn && h('Icon', {
                props: {
                  type: 'md-warning',
                  color: '#ed4014'
                },
                style: {
                  marginRight: '4px'
                }
              }),
              h('span', value + '%')
            ]);
          }
        },
        {
          title: [1013043, 1013117].includes(Number(this.searchForm.publisherId)) ? 'Nova Install' : '协议 Install',
          key: "nova_install",
          width: 120
        },
        {
          title: "DDJ Install：协议 Install",
          key: "dpRate",
          width: 200,
          render: (h, params) => {
            return h('span', Number(params.row.dpRate || 0).toFixed(2))
          }
        },
        {
          title: "可分成收益",
          key: "share_count",
          width: 110
        },
        {
          title: "分成",
          key: "revenue",
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', '$' + (params.row.revenue || 0).toFixed(2))
          }
        }
      ]
    },
    isNovaInstallUser() {
      return ![1013043, 1013117].includes(Number(this.publisherId))
    }
  },
  watch: {
    'searchForm.publisherId': {
      immediate: true,
      handler(newVal) {
        this.publisherId = Number(newVal)
      }
    }
  },
  methods: {
    async handleSearch() {
      this.page = 1;
      await this.getListData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getListData();
    },
    async handlePageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.page = 1;
      await this.getListData();
    },
    async handleDownload() {
      this.downloading = true;
      try {
        const params = {
          publisherId: this.searchForm.publisherId,
          startDay: '',
          endDay: '',
          offerId: this.searchForm.offerId,
          pkg: this.searchForm.pkg
        };

        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDay = moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD');
          params.endDay = moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD');
        }

        await exportCpsRevenue({
          ...params,
          limit: this.pageSize,
          page: this.page,
          url: '/user/exportPublisherCpsOffersRevenue'
        });
      } catch (error) {
        this.$Message.error('Export Failed');
      }
      this.downloading = false;
    },
    async getListData() {
      this.loading = true;
      try {
        const params = {
          publisherId: this.searchForm.publisherId,
          startDay: '',
          endDay: '',
          offerId: this.searchForm.offerId,
          pkg: this.searchForm.pkg
        };

        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDay = moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD');
          params.endDay = moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD');
        }

        const { data } = await getCpsRevenue({
          ...params,
          limit: this.pageSize,
          page: this.page
        });

        if (data.code === 200) {
          const cleanedData = data.data.list.map(row => ({
            date: row.dt,
            ads_id: row.offerId,
            pkg: row.pkg,
            click_count: row.clickCount,
            cvr: parseFloat(row.cvr),
            reject_count: row.rejectCount,
            reject_rate: parseFloat(row.rejectRate),
            nova_install: row.pubInstalls,
            dpRate: parseFloat(row.dpRate),
            installs: row.installs,
            share_count: (row.cost),
            revenue: parseFloat(row.pubCost)
          }));

          const summary = {
            date: 'Total',
            ads_id: '',
            pkg: '',
            click_count: data.data.totalRevenue.clickCount,
            cvr: parseFloat(data.data.totalRevenue.cvr),
            reject_count: data.data.totalRevenue.rejectCount,
            reject_rate: parseFloat(data.data.totalRevenue.rejectRate),
            nova_install: data.data.totalRevenue.pubInstalls,
            dpRate: parseFloat(data.data.totalRevenue.dpRate),
            installs: data.data.totalRevenue.installs,
            share_count: (data.data.totalRevenue.cost),
            revenue: parseFloat(data.data.totalRevenue.pubCost)
          };

          this.tableData = [summary, ...cleanedData];
          this.total = data.data.total;
        }
      } catch (error) {
        this.$Message.error('Failed to get data');
      }
      this.loading = false;
    },
    rowClassName(row) {
      return (parseFloat(row.reject_rate) > 30 && row.reject_count > 0) ? 'high-reject-rate-row' : '';
    },
    async getPublisherList() {
      const { data } = await getPublisherList()
      if (data.code === 200) {
        if (data.data.nicknames && data.data.nicknames.length > 0) {
          this.publisherId = Number(data.data.nicknames[0].publisherId)
        }
        
        this.accountOptions = data.data.nicknames.map(obj => ({
          label: obj.nickname,
          value: obj.publisherId
        }))
        
        if (this.accountOptions.length > 0) {
          this.searchForm.publisherId = this.accountOptions[0].value
        }
      }
    },
    async initPage() {
      await this.getPublisherList();
      await this.getListData();
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="less" scoped>
.ivu-card + .ivu-card {
  margin-top: 20px;
}

.ivu-form {
  padding: 16px 0;
}

.ivu-form-item {
  margin-bottom: 0;
  width: 100%;
}

.ivu-input-wrapper,
.ivu-select {
  width: 100%;
}

.ivu-form-inline .ivu-form-item {
  margin-right: 0;
}

.ivu-btn {
  min-width: 80px;
}

.pagination-container {
  margin-top: 16px;
  text-align: right;
}

// 表格数字金额右对齐
/deep/ .ivu-table {
  .revenue-column {
    text-align: right;
  }
}

// 调整日期选择器样式
/deep/ .ivu-date-picker {
  width: 100%;
  
  .ivu-input {
    font-size: 14px;
  }
}

// 添加警告图标的动画效果
/deep/ .ivu-icon-md-warning {
  animation: warning-flash 1s ease-in-out infinite;
}

@keyframes warning-flash {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

// 修改表格相关样式
/deep/ .ivu-table {
  // 高亮行样式
  .high-reject-rate-row {
    &:hover td {
      background-color: rgba(237, 64, 20, 0.15) !important;
    }
  }

  // 斑马纹效果
  tr:nth-child(even) td {
    background-color: #f8f8f9;
  }

  // 所有行的hover效果
  tr:hover td {
    background-color: #ebf7ff;
  }

  // 高亮行的hover效果覆盖
  .high-reject-rate-row:hover td {
    background-color: rgba(237, 64, 20, 0.15) !important;
  }
}

.ivu-select {
  width: 100%;
}
</style> 